var _z$array;
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.set.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { z } from 'zod';

// TODO: remove this after https://github.com/piotrwitek/utility-types/pull/193/files is released
// https://stackoverflow.com/a/49402091

/**
 * Can be used in a union to keep auto-complete
 */
// eslint-disable-next-line @typescript-eslint/ban-types

export var allItemsUniqueRefinement = [function allItemsUnique(items) {
  return new Set(items).size === items.length;
}, {
  message: 'Must be an array of unique strings'
}];
export var ArrayOfUniqueStrings = (_z$array = z.array(z.string())).refine.apply(_z$array, allItemsUniqueRefinement);